import { parseToTree } from '../parseToTree/parseToTree';
import { renderTextFromTree } from '../renders/renderTextFromTree';

export const getPlainText = (text: string): string => {
  const tree = parseToTree({ text, isPlainText: true });

  return renderTextFromTree({ tree });
};
